import { RouteErrorBoundary } from 'es/app/components/layout/RouteErrorBoundary';
import RouteMap from 'es/app/views/system/RouteMap';
import { lazy } from 'react';
import { Route } from 'react-router';

const AccessGroups = lazy(() => import('es/app/views/system/access-groups'));
const EditAccessGroups = lazy(() => import('es/app/views/system/access-groups/edit'));

export function AccessGroupRoutes() {
    return (
        <Route path={RouteMap.accessGroups.search()} element={<AccessGroups />} ErrorBoundary={RouteErrorBoundary}>
            {[RouteMap.accessGroups.create(), RouteMap.accessGroups.edit()].map(route => (
                <Route path={route} key={route} element={<EditAccessGroups />} />
            ))}
        </Route>
    );
}
